import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import LabeledOption from '../react-labeled-option';

function SortBySection({features = [], onChange}) {
  const optionsMap = features.map(({key, selected, label, value}) => (
    <LabeledOption
      key={key}
      onClick={(event) => {
        onChange({event, key, label, value, selected: true});
      }}
      selected={selected}
      label={label}
      id={key}
      typeOfInput="Radio"
    />
  ));

  return (
    <div className="ListingsFilter__sectionContainer">
      <div className="ListingsFilter__sectionContainer__Header">
        <FormattedMessage defaultMessage="Sort By" id="ListingsFilter.sortByHeader" />
      </div>
      {optionsMap}
    </div>
  );
}

SortBySection.propTypes = {
  features: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func.isRequired,
};

export default SortBySection;
